import Vue from 'vue'
import lang from 'element-ui/lib/locale/lang/it'
import locale from 'element-ui/lib/locale'
// configure language
locale.use(lang)

export default async () => {
  Vue.use(require('element-ui/lib/col').default)
  Vue.use(require('element-ui/lib/row').default)
  Vue.use(require('element-ui/lib/main').default)
  Vue.use(require('element-ui/lib/input').default)
  Vue.use(require('element-ui/lib/button').default)
  Vue.use(require('element-ui/lib/select').default)
  Vue.use(require('element-ui/lib/tag').default)
  Vue.use(require('element-ui/lib/option').default)
  Vue.use(require('element-ui/lib/table').default)
  Vue.use(require('element-ui/lib/table-column').default)
  Vue.use(require('element-ui/lib/card').default)
  Vue.use(require('element-ui/lib/header').default)
  Vue.use(require('element-ui/lib/menu').default)
  Vue.use(require('element-ui/lib/menu-item-group').default)
  Vue.use(require('element-ui/lib/menu-item').default)
  Vue.use(require('element-ui/lib/submenu').default)
  Vue.use(require('element-ui/lib/icon').default)
  Vue.use(require('element-ui/lib/form').default)
  Vue.use(require('element-ui/lib/form-item').default)
  Vue.use(require('element-ui/lib/collapse').default)
  Vue.use(require('element-ui/lib/collapse-item').default)
  Vue.use(require('element-ui/lib/alert').default)
  Vue.use(require('element-ui/lib/radio-group').default)
  Vue.use(require('element-ui/lib/radio-button').default)
  Vue.use(require('element-ui/lib/date-picker').default)
  Vue.use(require('element-ui/lib/input-number').default)
  Vue.use(require('element-ui/lib/dropdown').default)
  Vue.use(require('element-ui/lib/dropdown-item').default)
  Vue.use(require('element-ui/lib/dropdown-menu').default)
  Vue.use(require('element-ui/lib/pagination').default)
}
